import { connect } from 'react-redux';

import { closeCountryCurrencySettings } from 'shared/store/internationalization/actions';
import { setData as _setData } from 'shared/store/internationalization/services';
import {
  getCountries,
  getCurrencies,
  getUserI18N,
} from 'shared/store/internationalization/selectors';

import Internationalization from './Internationalization';

const mapStateToProps = (state: any) => {
  return {
    countries: getCountries(state),
    currencies: getCurrencies(state),
    openDialog: state.internationalization.openDialog,
    userI18N: getUserI18N(state),
    isLoading: state.internationalization.isLoading,
  };
};

const mapDispatchToProps = {
  hide: closeCountryCurrencySettings,
  setData: _setData,
};

export default connect(mapStateToProps, mapDispatchToProps)(Internationalization);
